import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SessionService } from "src/app/services/session.service";
import { environment } from "src/environments/environment";
import { INotificationAreaLimitModel } from "../models/veg-wizard-models";

@Injectable({
  providedIn: 'root'
})
export class NotificationAreaLimitService {

  constructor(private http: HttpClient,
    private sessionService: SessionService) { }

  getNotificationAreaLimit$(categoryPurposeIds: number[], isCoastalSelected: boolean | null | undefined): Observable<INotificationAreaLimitModel> {

    const sessionId = this.sessionService.getSessionIdOrError();

    let url = `${environment.apiUrl}/session/notification-area-limit?`;
    url += "sessionKey=" + encodeURIComponent("" + sessionId) + "&";

    if (categoryPurposeIds !== undefined)
      categoryPurposeIds && categoryPurposeIds.forEach(item => { url += "categoryPurposeIds=" + encodeURIComponent("" + item) + "&"; });

    if (isCoastalSelected !== undefined && isCoastalSelected !== null)
      url += "isCoastalSelected=" + encodeURIComponent("" + isCoastalSelected) + "&";

    url = url.replace(/[?&]$/, "");

    return this.http.get<INotificationAreaLimitModel>(url)

  }
}
